import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  Input,
  QueryList,
  ViewEncapsulation,
} from '@angular/core';
import { BoschUiStepIndicatorStepComponent } from './bosch-ui-step-indicator-step/bosch-ui-step-indicator-step.component';
import { getRandomId } from '../../utils/get-random-id';

@Component({
  selector: 'bosch-ui-step-indicator',
  templateUrl: './bosch-ui-step-indicator.component.html',
  styleUrls: ['./bosch-ui-step-indicator.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiStepIndicatorComponent {
  @Input() small = false;
  @ContentChildren(BoschUiStepIndicatorStepComponent) steps: QueryList<BoschUiStepIndicatorStepComponent> | null = null;
  readonly id = getRandomId('step-indicator');

  trackByFn(index: number): string {
    return `${index}_${this.id}`;
  }
}
